module.exports = __webpack_public_path__ + "img/icon1.d4628ec7.png";